import React from 'react';
import { Nav } from './components/Nav';
import { Hero } from './components/Hero';
import { TrustStrip } from './components/TrustStrip';
import { GartnerBadge } from './components/GartnerBadge';
import { AsFeaturedIn } from './components/AsFeaturedIn';
import { Services } from './components/Services';
import { CaseStudies } from './components/CaseStudies';
import { About } from './components/About';
import { Testimonials } from './components/Testimonials';
import { Insights } from './components/Insights';
import { CtaBlock } from './components/CtaBlock';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-base text-primary font-sans selection:bg-accent selection:text-base" data-id="element-0">
      <Nav data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <TrustStrip data-id="element-4" />
        <GartnerBadge data-id="element-5" />
        <Services data-id="element-6" />
        <CaseStudies data-id="element-7" />
        <AsFeaturedIn data-id="element-8" />
        <About data-id="element-9" />
        <Testimonials data-id="element-10" />
        <Insights data-id="element-11" />
        <CtaBlock data-id="element-12" />
      </main>
      <Footer data-id="element-13" />
    </div>;
}